import React from 'react';
import { Zap, Timer, Flag } from 'lucide-react';

export const getSprintPoints = (breakdown = {}) => {
  const poleTime = breakdown.sprint_pole_time;
  return (breakdown.sprint_winner || 0) + (breakdown.sprint_pole_winner || 0) +
    ((typeof poleTime === 'object' ? poleTime?.points : poleTime) || 0);
};

const Row = ({ testId, icon, label, value, points, isScored }) => (
  <div className="flex items-center justify-between" data-testid={testId}>
    <span className="text-gray-400 flex items-center">{icon}{label}: <span className={value ? 'text-white ml-1' : 'text-gray-500 italic ml-1'}>{value || 'Niet ingevuld'}</span></span>
    {isScored && (
      <span className={`px-1 rounded ${points > 0 ? 'bg-purple-500/20 text-purple-300' : 'bg-gray-500/20 text-gray-400'}`}>+{points}</span>
    )}
  </div>
);

export const SprintPredictionBlock = ({ prediction, getDriverName }) => {
  const { sprint_winner, sprint_pole_winner, sprint_pole_time, score_breakdown = {}, is_scored, is_sprint_weekend } = prediction;
  if (!is_sprint_weekend && !sprint_winner && !sprint_pole_winner && !sprint_pole_time) return null;
  const total = getSprintPoints(score_breakdown);
  const poleTimeBd = score_breakdown.sprint_pole_time;
  const poleTimePoints = (typeof poleTimeBd === 'object' ? poleTimeBd?.points : poleTimeBd) || 0;

  return (
    <div className="bg-[#1a2332] border border-purple-500/60 rounded p-2" data-testid="sprint-prediction-block">
      <h4 className="font-semibold text-purple-300 mb-2 flex items-center justify-between text-xs">
        <span className="flex items-center"><Zap className="mr-1 text-purple-400" size={12} />Sprint Weekend</span>
        {is_scored && (
          <span className="text-xs bg-purple-500/30 text-purple-200 px-1.5 py-0.5 rounded" data-testid="sprint-total-points">+{total}</span>
        )}
      </h4>
      <div className="space-y-1 text-xs">
        <Row testId="sprint-pole-winner-row" icon={<Flag size={10} className="mr-1" />} label="Sprint pole" value={sprint_pole_winner && getDriverName(sprint_pole_winner)} points={score_breakdown.sprint_pole_winner || 0} isScored={is_scored} />
        <Row testId="sprint-pole-time-row" icon={<Timer size={10} className="mr-1" />} label="Pole tijd" value={sprint_pole_time} points={poleTimePoints} isScored={is_scored} />
        <Row testId="sprint-winner-row" icon={<Flag size={10} className="mr-1" />} label="Sprintwinnaar" value={sprint_winner && getDriverName(sprint_winner)} points={score_breakdown.sprint_winner || 0} isScored={is_scored} />
      </div>
    </div>
  );
};
